export default __webpack_public_path__ + "src/assets/contract-deploy.322054d3ccc347ef3f6b14600ded5f5b.svg";